import React, { useLayoutEffect, useState } from 'react';
import cn from 'classnames';
import { isEqual } from 'lodash';
import style from './index.module.scss';
import { connect } from 'react-redux';
const CustomKeyboard = props => {

  const layouts = {
    text: {
      default: [
        '1 2 3 4 5 6 7 8 9 0',
        'q w e r t y u i o p',
        'a s d f g h j k l',
        '{shift} z x c v b n m {bksp}',
        '{alt} {space} {done}',
      ],
      shift: [
        '1 2 3 4 5 6 7 8 9 0',
        'Q W E R T Y U I O P',
        'A S D F G H J K L',
        '{shift} Z X C V B N M {bksp}',
        '{alt} {space} {done}',
      ],
      alt: [
        '1 2 3 4 5 6 7 8 9 0',
        '@ # ₹ _ & - + ( ) /',
        `* " ' : ; ! ? % ^`,
        '= $ { } € 𝜋 [ ] {bksp}',
        '{default} , {space} . {done}',
      ],
    },
    textWithOutDone: {
      default: [
        '1 2 3 4 5 6 7 8 9 0',
        'q w e r t y u i o p',
        'a s d f g h j k l',
        '{shift} z x c v b n m {bksp}',
        '{alt} {space} {return}',
      ],
      shift: [
        '1 2 3 4 5 6 7 8 9 0',
        'Q W E R T Y U I O P',
        'A S D F G H J K L',
        '{shift} Z X C V B N M {bksp}',
        '{alt} {space} {return}',
      ],
      alt: [
        '1 2 3 4 5 6 7 8 9 0',
        '@ # ₹ _ & - + ( ) /',
        `* " ' : ; ! ? % ^`,
        '= $ { } € 𝜋 [ ] {bksp}',
        '{default} , {space} . {return}',
      ],
    },
    emailText: {
      default: [
        '1 2 3 4 5 6 7 8 9 0',
        'q w e r t y u i o p',
        'a s d f g h j k l',
        '{shift} z x c v b n m {bksp}',
        `{alt} .com {space} @ ${props.isDone ? '{done}' : '{return}'}`,
      ],
      shift: [
        '1 2 3 4 5 6 7 8 9 0',
        'Q W E R T Y U I O P',
        'A S D F G H J K L',
        '{shift} Z X C V B N M {bksp}',
        `{alt} .com {space} @ ${props.isDone ? '{done}' : '{return}'}`,
      ],
      alt: [
        '1 2 3 4 5 6 7 8 9 0',
        '@ # ₹ _ & - + ( ) /',
        `* " ' : ; ! ? % ^`,
        '= $ { } € 𝜋 [ ] {bksp}',
        `{default} , {space} . ${props.isDone ? '{done}' : '{return}'}`,
      ],
    },
    surveyText: {
      default: [
        '` 1 2 3 4 5 6 7 8 9 0 - = {bksp}',
        'q w e r t y u i o p [ ] \\',
        "a s d f g h j k l ; ' {surveyBack}",
        '{shift} z x c v b n m , . / {shift}',
        '.com {alt} @ {space} {done}',
      ],
      shift: [
        '~ ! @ # $ % ^ & * ( ) _ + {bksp}',
        'Q W E R T Y U I O P { } |',
        'A S D F G H J K L : " {surveyBack}',
        '{shift} Z X C V B N M < > ? {shift}',
        '.com {alt} @ {space} {done}',
      ],
      alt: [
        '@ # & * - + = ( ) {bksp}',
        '1 2 3 4 5 6 7 8 9 0 \\',
        '% ^ ~ | [ ] < > { } {surveyBack}',
        '{shift} _ $ " , : ; . ? / {shift}',
        '.com {default} {space} {done}',
      ],
    },

    number: {
      numericAlpha: ['1 2 3', '4 5 6', '7 8 9', '{default} 0 {bksp}', '{done}'],
      numericDefault: ['1 2 3', '4 5 6', '7 8 9', '{bin} 0 {bksp}'],
      numericDefaultWithDone: ['1 2 3', '4 5 6', '7 8 9', '{bksp} 0 {done}'],
      numericDot: ['1 2 3', '4 5 6', '7 8 9', '{bksp} 0 .'],
      numericWithDotClear: ['1 2 3', '4 5 6', '7 8 9', '{clear} 0 .'],
      numericDefaultWithDot:
        props.isDot && !props.typed?.includes('.')
          ? ['1 2 3', '4 5 6', '7 8 9', '. 0 {bksp} {done}']
          : ['1 2 3', '4 5 6', '7 8 9', '0 {bksp} {done}'],
      numericShift: ['! / #', '$ % ^', '& * (', '{shift} ) +', '{bksp}'],
      numericSwipe: ['1 2 3', '4 5 6', '7 8 9', '{swipe} 0 {bksp}'],
      numeric: props.isClr
        ? ['1 2 3', '4 5 6', '7 8 9', '{bin} 0 00']
        : ['1 2 3', '4 5 6', '7 8 9', '{bksp} 0 '],
      numericDefaultWithoutDone:
        props.isDot && !props.typed?.includes('.')
          ? ['1 2 3', '4 5 6', '7 8 9', '. 0 {bksp}']
          : ['1 2 3', '4 5 6', '7 8 9', '. 0 {bksp}'],
      numericWithBin: ['1 2 3', '4 5 6', '7 8 9', '{bin} 0 {bksp}'],
      numericAlphaWithoutDone: ['1 2 3', '4 5 6', '7 8 9', '{default} 0 {bksp}'],
      numericWithdone: ['1 2 3', '4 5 6', '7 8 9', '{bin} 0 {bksp}', '{done}'],
    },
  };

  const returnLayout = value => {
    switch (value) {
      case 'text':
        return layouts.text.default;
      case 'surveyText':
        return layouts.surveyText.default;
      case 'emailText':
          return layouts.emailText.default;
      case 'textWithOutDone':
        return layouts.textWithOutDone.default;
      case 'number':
        return layouts.number.numericDefault;
      case 'numericAlpha':
        return layouts.number.numericAlpha;
      case 'swipe':
        return layouts.number.numericSwipe;
      case 'numeric':
        return layouts.number.numeric;
      case 'dot':
        return layouts.number.numericDefaultWithDot;
      case 'withoutDone':
        return layouts.number.numericDefaultWithoutDone;
      case 'numericWithDot':
        return layouts.number.numericWithDotClear;
      case 'numericDot':
        return layouts.number.numericDot;
      case 'numericWithBin':
        return layouts.number.numericWithBin;
      case 'numericWithdone':
        return layouts.number.numericWithdone;
      case 'numericAlphaWithoutDone':
        return layouts.number.numericAlphaWithoutDone;
      case 'numericDefaultWithDone':
          return layouts.number.numericDefaultWithDone;  
      default:
        return layouts.text.default;
    }
  };

  const [layout, setLayout] = useState(returnLayout(props.type));

  const customUnicodes ={
    'bksp': <svg width="36" height="21" viewBox="0 0 36 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.6079 1.20986C13.7832 1.07383 13.9988 1 14.2208 1H34C34.5523 1 35 1.44772 35 2V19C35 19.5523 34.5523 20 34 20H14.2208C13.9988 20 13.7832 19.9262 13.6078 19.7901L2.65014 11.2901C2.13403 10.8898 2.13403 10.1102 2.65014 9.70986L13.6079 1.20986Z" stroke={props.serverAppTheme.primary_text} stroke-width="2"/><line x1="1.5" y1="-1.5" x2="12.1227" y2="-1.5" transform="matrix(0.849337 0.527852 -0.959363 0.282177 15 7)" stroke={props.serverAppTheme.primary_text} stroke-width="3" stroke-linecap="round"/><line x1="1.5" y1="-1.5" x2="12.1227" y2="-1.5" transform="matrix(0.849337 -0.527852 0.959363 0.282177 17.6509 14.4111)" stroke={props.serverAppTheme.primary_text} stroke-width="3" stroke-linecap="round"/></svg>, 
    'shift': <svg width="29" height="23" viewBox="0 0 29 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.51915 21.7049H21.1314M5.36201 14.848C2.34615 14.848 0.798825 11.833 2.87973 10.0111L11.6696 2.31549C13.3875 0.811502 16.2631 0.811504 17.9809 2.31549L26.8802 10.1069C28.9199 11.8927 27.4032 14.848 24.4471 14.848C23.5188 14.848 22.7663 15.4761 22.7663 16.2508V16.3857C22.7663 18.0842 21.1165 19.4611 19.0813 19.4611H10.7617C8.72654 19.4611 7.07672 18.0842 7.07672 16.3857V16.2791C7.07672 15.4887 6.30902 14.848 5.36201 14.848Z" stroke={props.serverAppTheme.primary_text} stroke-width="2" stroke-linecap="round"/></svg>,
    'return': <svg width="50" height="25" viewBox="0 0 50 25" fill="none" xmlns="http://www.w3.org/2000/svg"><line x1="1.86599" y1="15.3249" x2="10.8874" y2="7.80784" stroke={props.serverAppTheme.primary_text} stroke-width="3" stroke-linecap="round"/><line x1="2.11079" y1="15.7889" x2="10.7889" y2="22.8892" stroke={props.serverAppTheme.primary_text} stroke-width="3" stroke-linecap="round"/><path d="M33.9764 2V6.70502C33.9764 12.2975 30.5329 16.0214 24.9405 15.9878C17.8471 15.945 8.17867 15.8052 2 15.8052" stroke={props.serverAppTheme.primary_text} stroke-width="3" stroke-linecap="round"/></svg>,
    'bin': <svg width="22" height="26" viewBox="0 0 22 26" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.01641 25.8489C3.28005 25.8489 2.64969 25.5705 2.12531 25.0138C1.60093 24.4571 1.33874 23.7879 1.33874 23.0062V4.52868H-9.15527e-05V1.68599H6.69408V0.264648H14.7271V1.68599H21.4213V4.52868H20.0824V23.0062C20.0824 23.7879 19.8202 24.4571 19.2959 25.0138C18.7715 25.5705 18.1411 25.8489 17.4048 25.8489H4.01641ZM17.4048 4.52868H4.01641V23.0062H17.4048V4.52868ZM6.69408 20.1635H9.37176V7.37138H6.69408V20.1635ZM12.0494 20.1635H14.7271V7.37138H12.0494V20.1635Z" fill={props.serverAppTheme.primary_text}/></svg>
  }
  const onclick = f => {
    switch (f) {
      case '{swipe}':
        return (
          props.auth.serverAppFeatures.supportsLoginUsingCard &&
          props.goToSwipe()
        );
      case '{space}':
      case '{tab}':
        return props.onClickBtn('  ');
        case '{done}': return props?.isAlphaNumericFlag ? (props?.setIsDoneClick(true), props?.closeKeyboard()) : props?.closeKeyboard();
      case '{return}' :
      case '{enter}':
        return props?.closeKeyboard();
      case '{surveyBack}':
        return props?.closeKeyboard();
      case '{bin}':
        return props.setinputEmpty();
      default:
        return props.onClickBtn(f);
    }
  };

  const handleClick = f => {
    if (
      (props.type === 'text' ||
        isEqual(layout, layouts.text.default) ||
        isEqual(layout, layouts.text.shift)) &&
      (f === '{shift}' || f === '{lock}')
    ) {
      setLayout(
        isEqual(layout, layouts.text.shift)
          ? layouts.text.default
          : layouts.text.shift
      );
    } else if (
      (props.type === 'text' ||
        isEqual(layout, layouts.text.default) ||
        isEqual(layout, layouts.text.alt) ||
        isEqual(layout, layouts.text.shift)) &&
      (f === '{alt}' || f === '{default}')
    ) {
      setLayout(
        isEqual(layout, layouts.text.alt)
          ? layouts.text.default
          : layouts.text.alt
      );
    }
    else if (
      (props.type === 'emailText' ||
        isEqual(layout, layouts.emailText.default) ||
        isEqual(layout, layouts.emailText.shift)) &&
      (f === '{shift}' || f === '{lock}')
    ) {
      setLayout(
        isEqual(layout, layouts.emailText.shift)
          ? layouts.emailText.default
          : layouts.emailText.shift
      );
    } else if (
      (props.type === 'emailText' ||
        isEqual(layout, layouts.emailText.default) ||
        isEqual(layout, layouts.emailText.alt) ||
        isEqual(layout, layouts.emailText.shift)) &&
      (f === '{alt}' || f === '{default}')
    ) {
      setLayout(
        isEqual(layout, layouts.emailText.alt)
          ? layouts.emailText.default
          : layouts.emailText.alt
      );
    } else if (
      (props.type === 'surveyText' ||
        isEqual(layout, layouts.surveyText.default) ||
        isEqual(layout, layouts.surveyText.shift)) &&
      f === '{shift}'
    ) {
      setLayout(
        isEqual(layout, layouts.surveyText.shift)
          ? layouts.surveyText.default
          : layouts.surveyText.shift
      );
    } else if (
      (props.type === 'surveyText' ||
        isEqual(layout, layouts.surveyText.default) ||
        isEqual(layout, layouts.surveyText.alt) ||
        isEqual(layout, layouts.surveyText.shift)) &&
      (f === '{alt}' || f === '{default}')
    ) {
      setLayout(
        isEqual(layout, layouts.surveyText.alt)
          ? layouts.surveyText.default
          : layouts.surveyText.alt
      );
    } else if (
      (props.type === 'textWithOutDone' ||
        isEqual(layout, layouts.textWithOutDone.default) ||
        isEqual(layout, layouts.textWithOutDone.shift)) &&
      (f === '{shift}' || f === '{lock}')
    ) {
      setLayout(
        isEqual(layout, layouts.textWithOutDone.shift)
          ? layouts.textWithOutDone.default
          : layouts.textWithOutDone.shift
      );
    } else if (
      (props.type === 'textWithOutDone' ||
        isEqual(layout, layouts.textWithOutDone.default) ||
        isEqual(layout, layouts.textWithOutDone.alt) ||
        isEqual(layout, layouts.textWithOutDone.shift)) &&
      (f === '{alt}' || f === '{default}')
    ) {
      setLayout(
        isEqual(layout, layouts.textWithOutDone.alt)
          ? layouts.textWithOutDone.default
          : layouts.textWithOutDone.alt
      );
    } else if (
      (props.type === 'number' || props.type === 'numericAlpha' || props.type === 'numericAlphaWithoutDone') &&
      f === '{default}'
    ) {
      props.setKeyboardType('text');
      setLayout(layouts.text.default);
    } else if (
      (Number(props.maxLength) > 0 &&
        props.typed?.length < Number(props.maxLength)) ||
      f === '{done}' ||
      f === '{bksp}' ||
      f === '{default}' ||
      f === '{lock}' ||
      f === '{shiftActivated}' ||
      f === '{shift}'
    ) {
      onclick(f);
    } else if (!props.maxLength) {
      onclick(f);
    }
  };

  const display = {
    '{alt}': '#+=',
    '{smileys}': '\uD83D\uDE03',
    // '{shift}': '⇧',
    '{shift}': customUnicodes.shift,
    '{tab}': 'Tab',
    '{shiftactivated}': '⇧',
    '{enter}': 'return',
    '{bksp}': props.type === 'text' || props.type ==='textWithOutDone' || props.type ==='emailText' ? customUnicodes.bksp :  '⌫',
    '{altright}': '.?123',
    '{downkeyboard}': '🞃',
    '{space}': ' ',
    '{default}': 'ABC',
    '{back}': '⇦',
    '{lock}': 'Caps',
    '{swipe}':
      props.type === 'swipe' &&
      props.auth.serverAppFeatures.supportsLoginUsingCard
        ? '💳'
        : <>&nbsp;</>,
    '{done}': 'Done',
    '{return}': customUnicodes.return,
    '{clear}': 'CLR',
    '{surveyBack}': '⇦',
    '{bin}' : customUnicodes.bin,
  };

  const returnWidth = key => {
    switch (key) {
      case '{space}':
        return (isEqual(layout, layouts.emailText.default) || isEqual(layout, layouts.emailText.shift)) && !isLandScape ? 'w-100 col-5' : (isEqual(layout, layouts.emailText.default) || isEqual(layout, layouts.emailText.shift)) && isLandScape ? 'w-100 col-8' : (isEqual(layout, layouts.text.alt) || isEqual(layout, layouts.textWithOutDone.alt)) ?  'w-100 col-7' : (isEqual(layout, layouts.text.default) || isEqual(layout, layouts.textWithOutDone.default) || isEqual(layout, layouts.text.shift) || isEqual(layout, layouts.textWithOutDone.shift)) && !isLandScape ? 'col-8':  'w-100 col-9';
      case '{alt}':
        return 'w-25 col-1 overflow-hidden';
      case '{default}':
        return 'w-25';
      case '@':
        return 'w-15';
      case '{done}':
        return props.type === 'number' ||
          props.type === 'numericAlpha' ||
          props.type === 'numeric' ||
          props.type === 'swipe'
          ? 'w-100'
          : 'w-20';
      case '{shift}':
        return 'col-1';
      default:
        return 'w-12';
    }
  };

  const returnStyle = key => {
    if(props.type === 'text' || props.type ==='textWithOutDone' || props.type ==='emailText' ){
    switch (key) {
      case '{space}':
        return ` ${props.spacebtn} ${!isLandScape ? props.screenType === 'couponPopUp' ? '' : style.spaceBtnHeightP : style.spaceBtnHeight}`;
      case '{done}':
        return style.doneBtn;
      case "{shift}":
        return 'px-3' ;
      case "{bksp}":
        return 'px-3';
      // case '{return}':
      //   return style.Btn;
      default:
        return 'w-12';
    }
  }else{
    switch (key) {
      case '{done}':
        return `${style.doneBtn}`;
      default:
        return style.numbtnsize;  
    }
    }
  };

  const returnBtnSize = () => {
    if (props.isPaymentApp) {
      return 'btn35';
    } else {
      return props.btnSize;
    }
  };

  const returnKeyboard = (e, index) => {
    const topLeft = index === 0;
    const topRight = index === 3;
    return (
      <>
        {e?.split(' ').length > 0 &&
          e.split(' ').map((f, i) => (
            <button
              key={Number(i)}
              className={cn(
                (props.type === 'number' ||
                  props.type === 'withoutDone' ||
                  props.type === 'numericAlpha' ||
                  props.type === 'numeric' ||
                  props.type === 'swipe') &&
                  !(
                    isEqual(layout, layouts.text.default) ||
                    isEqual(layout, layouts.text.shift) ||
                    isEqual(layout, layouts.text.alt)
                  )
                  ? props.btnSize
                  : returnBtnSize(),
                i%3 === 2 ? 'h-100 px-1 py-1 mt-1 mr-1' :'h-100 px-1 py-1 mr-1 mt-1',
                (props.type === 'text' || props.type ==='textWithOutDone' || props.type ==='emailText' ) ? (style.keyStylesAlpha) : (props.type === 'numericAlpha' || props.screenType === 'loyalty' || props.screenType === 'payAnAmount' || props.screenType === 'cashCalculator' || props.screenType === 'otherAmount' || props.screenType === 'receiptPopUp' || props.screenType === 'checkCreate' || props.screenType === 'otherOrder'|| props.screenType === 'textreceiptPopUp' || props.screenType === 'voidPopUp' || props.screenType === 'QrSendPopUp' || props.screenType === 'openDollarPopUp') ? style.keyStyleLoyalty : style.keyStyles, returnStyle(f),
                index > 3 ? returnWidth(f) : 'w-100',
                (props.type === 'text' || props.type ==='textWithOutDone' || props.type ==='emailText') && !isLandScape ? style.lineHeight_btn2 : style.lineHeight_btn,
                topLeft &&  props.type === 'number' ? style.cornerButtonTop : '',
                topRight &&  props.type === 'number' ? style.cornerButtonButtom : '',
                (props.buttonTheme ? props.buttonTheme : '') || ''
              )}
              style={{backgroundColor:f === '{done}' ? '#0060FF' : props.serverAppTheme.keyBoard_key_Color, color:f === '{done}' ? '#FFF' : props.serverAppTheme.primary_text}}
              type="button"
              onClick={() => handleClick(f)}
              disabled={props.isDot && props.typed?.includes('.') && f==='.'}
            >
              {display[f] ? display[f] : f === '{swipe}' ? '' : f}
            </button>
          ))}
      </>
    );
  };

  const returnFontSize = () => {
    if (props.customClass.includes('fs')) {
      return props.customClass;
    }
    return style.fontSize;
  };

  useLayoutEffect(() => {
    setLayout(returnLayout(props.type));
  }, [props.type, props.typed.includes('.')]);

  return (
    <div
      className={cn(
        `col-12 m-0 h-100 ${style.border} ${returnFontSize()} ${style.backgroundColour} ${style.keyboardcontainerHeight} ${props.customClass}`,
        props.screenType === 'couponPopUp' ? 'px-1 py-0' : 'p-0',
        props.screenType === 'textreceiptPopUp' && 'pl-1 pb-1',
        props.screenType === 'openDollarPopUp' && 'pb-1'
      )}
      style={{backgroundColor:(props.screenType === 'textreceiptPopUp' || props.screenType ==='openDollarPopUp') ? props.serverAppTheme.keyBoard_Bg_Color : props.serverAppTheme.keyBoard_Bg_Color}}
    >
      {layout?.length > 0 &&
        layout?.map((e, index) => (
          <div
            key={Number(index)}
            className={cn(
              props.type === 'number' ||
                props.type === 'numericAlpha' ||
                props.type === 'numeric' ||
                props.type === 'swipe'
                ? 'col-12'
                : 'col',
              // index > 3 && 'col-12',
              props.type === "text" || props.type ==='textWithOutDone' || props.type ==='emailText' ? index === 2 ? 'px-5' : index === 3 ? 'px-3': 'col-12' : '',
              'd-flex px-0',
              'd-flex px-0', props.customizeKeyBoard,
              ''
            )}
          >
            {returnKeyboard(e, index)}
          </div>
        ))}
    </div>
  );
};

const mapStateToProps =({theme}) => ({
  serverAppTheme: theme.serverAppTheme,
 })
 export default connect (mapStateToProps, null) (CustomKeyboard);
